import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {DynamicDataComponent} from './dynamic-data.component';
import {DynamicDataFilterModule} from '../dynamicDataFilter/dynamic-data-filter.module';
import {LoginCirclesModule} from '../loading-animation-2/loading-circles.module';
import {ImageViewerModule} from '../imageViewer/image-viewer.module';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        DynamicDataFilterModule,
        LoginCirclesModule,
        ImageViewerModule
    ],
    declarations: [DynamicDataComponent],
    providers: [],
    exports: [DynamicDataComponent]
})

export class DynamicDataModule {

}
